import React from 'react';

interface NotificationBadgeProps {
  count: number;
  className?: string;
}

const NotificationBadge: React.FC<NotificationBadgeProps> = ({ count, className = '' }) => {
  if (count <= 0) return null;

  // Display the count, but limit to 99+ for very large numbers
  const displayCount = count > 99 ? '99+' : count.toString();

  return (
    <span
      className={`inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white bg-red-600 rounded-full min-w-[20px] h-5 ${className}`}
      title={`${count} pending ${count === 1 ? 'enrollment' : 'enrollments'}`}
    >
      {displayCount}
    </span>
  );
};

export default NotificationBadge;